import axios from 'axios';

let host = process.env.ENV_HOST;
let baseURL = "/admin";
let that;

export const setThat = t => {that = t}

// axios 请求拦截
axios.interceptors.request.use(config => {
    
    // 请求的地址会变成 baseURL+url的拼接值
    config.url = host + baseURL + config.url
    // 请求超时时间30s
    config.timeout = 30000
    // 为请求头对象，添加 ToKen 验证的 Authorization 字段
    config.headers.token = window.sessionStorage.getItem('token')
    config.headers.identity = 2

    console.log("请求地址：", config.url)
    console.log("请求类型：", config.method)
    console.log("请求入参：", config.data)

    // 必须 return 
    return config
}, err=> {
    console.log("请求超时：", config.url)
    return Promise.resolve(err);
})

axios.interceptors.response.use(response => {
    // 调用 Loading 实例的 close 方法即可关闭 loading 效果
    // loadingInstance()
    console.log("返回结果：", response)

    if (response.data.status.code == 200) {
        return response
    }

    if (response.data.status.code == 401 || response.data.status.code == 402) {
        that.$router.push({ path: '/login' });
    }

    throw new Error(response.data.status.message)
    
}, error => {
    console.log("请求失败：", error)
    if (error.response) {
        console.log("error.response:", error.response)
    } else if (error.request) {
        console.log("error.request:", error.request)
    } else {
        console.log('Error:', error.message)
    }
})



// WEBPACK FOOTER //
// ./src/api/apiConfig.js